@for(item of checklist; track item) {
  <app-service-checklist-item
    [item]="item"
    (itemChange)="checklistItemChange($event)"
  ></app-service-checklist-item>
}
